<template>
  <v-dialog
    v-model="opened"
    max-width="480px"
    perisistent
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card class="content-container">
      <v-card-title class="title">
        Select Template
        <v-spacer />
        <v-btn
          fab
          small
          class="error--text text-none my-0"
          flat
          @click="$emit('update:opened', false)"
        >
          <v-icon size="25">clear</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="selectedTemplateId"
          :items="questionnaireTemplates"
          item-text="name"
          item-value="id"
          class="default-input"
          solo
          hide-details
          placeholder="Select a template to copy the question to"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer class="hidden-xs-only" />
        <v-btn
          class="default-input primary text-none"
          @click="duplicateQuestion()"
          :disabled="!selectedTemplateId"
          :loading="loading"
        >
          Copy Question
        </v-btn>
        <v-btn
          class="error--text text-none"
          flat
          @click="$emit('update:opened', false)"
        >
          {{ $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';

export default {
  name: 'SelectTemplateDialog',
  props: {
    opened: {
      type: Boolean,
    },
    questionnaireTemplates: {
      type: Array,
    },
    selectedQuestion: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      selectedTemplateId: null,
    };
  },
  methods: {
    async duplicateQuestion() {
      try {
        this.loading = true;
        const response1 = await API.questionnaireTemplate.duplicateQuestionToOtherTemplate(
          {
            questionId: this.selectedQuestion.id,
            targetTemplateId: this.selectedTemplateId,
          },
        );
        if (response1.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response1.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Successfully copied.',
          });
          this.$emit('update:opened', false);
          this.$emit('refresh-questionnaire-template');
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem copying the question. Please refresh the page and try again.',
        });
      } finally {
        this.loading = false;
        this.selectedTemplateId = null;
      }
    },
  },
};
</script>

<style scoped lang="postcss"></style>
